<template>
  <v-row align="center" justify="center">
    <v-col class="text-center px-5" cols="12" md="9">
      <v-col cols="12">
        <v-btn
          icon
          title="Juzgados de Ejecución de Penas y Medidas de Seguridad"
          aria-label="Juzgados de Ejecución de Penas y Medidas de Seguridad"
        >
          <v-icon class="iconos" size="60">fas fa-gavel</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" class="mt-1">
        <span
          class="font-weight-bold leading--text mb-3"
          :style="
            $vuetify.breakpoint.xs ? 'font-size: 25px' : 'font-size: 32px'
          "
          >Juzgados de Ejecución de Penas <br />
          y Medidas de Seguridad</span
        >
        <v-row align="center" justify="center">
          <v-col cols="8" md="6" sm="6" class="mt-1">
            <v-autocomplete
              :items="items"
              v-model="name"
              item-text="name"
              item-value="value"
              label="Seleccione la ciudad..."
              dense
              outlined
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-btn
          color="success"
          class="mx-2 mt-n8 font-weight-bold"
          width="200"
          @click="goTojuzgados()"
          >Ir a Juzgado</v-btn
        >
        <div class="mt-2 caption">
          * Favor verificar la información con la Secretaría correspondiente
        </div>
      </v-col>
    </v-col>
  </v-row>
</template>
<script>
export default {
  data: () => ({
    name: {},
    items: [
      { name: 'ARMENIA-CALARCA', value: 'armeniajepms' },
      { name: 'BARRANQUILLA', value: 'barranquillajepms' },
      { name: 'BOGOTA', value: 'bogotajepms' },
      { name: 'BUCARAMANGA', value: 'bucaramangajepms' },
      { name: 'BUGA', value: 'bugajepms' },
      { name: 'CALI', value: 'calijepms' },
      { name: 'CARTAGENA', value: 'cartagenajepms' },
      { name: 'FLORENCIA', value: 'florenciajepms' },
      { name: 'IBAGUE', value: 'ibaguejepms' },
      { name: 'LA DORADA', value: 'ladoradajepms' },
      { name: 'MANIZALES', value: 'manizalesjepms' },
      { name: 'MEDELLIN', value: 'medellinjepms' },
      { name: 'MONTERIA', value: 'monteriajepms' },
      { name: 'NEIVA', value: 'neivajepms' },
      { name: 'PALMIRA', value: 'palmirajepms' },
      { name: 'PASTO', value: 'pastojepms' },
      { name: 'PEREIRA', value: 'pereirajepms' },
      { name: 'POPAYAN', value: 'popayanjepms' },
      { name: 'QUIBDO', value: 'quibdojepms' },
      { name: 'SANTA MARTA', value: 'santamartajepms' },
      { name: 'TUNJA', value: 'tunjajepms' },
      { name: 'VALLEDUPAR', value: 'valleduparjepms' },
      { name: 'VILLAVICENCIO', value: 'villavicenciojepms' },
    ],
  }),
  methods: {
    goTojuzgados() {
      window.open(
        `https://procesos.ramajudicial.gov.co/jepms/${this.name}/conectar.asp`,
      );
    },
  },
  created() {
    this.$store.dispatch(
      'process/setUrlAyuda',
      '/manual/consulta.html#consulta-juzgados-de-ejecucion-de-penas-y-medidas-de-seguridad',
    );
  },
};
</script>
<style scoped>
>>> .theme--light.v-list-item .v-list-item__mask {
  color: rgba(0, 0, 0, 0.38);
  background: #daffd9 !important;
}
</style>
